<template>
    <div>
        <paginate class="ul-pagination" name="items" :list="items" :per="9">
            <div class="pr-5 table-responsive">
                <table class="mt-4 table-sm table table-commercial table-striped">
                    <caption class="visually-hidden">List History</caption>
                    <thead>
                        <tr>
                            <th class="td-commercial" scope="col">Nombre</th>
                            <th class="td-commercial" scope="col">Tapas</th>
                            <th class="td-commercial" scope="col">Fecha de registro</th>
                            <th class="td-commercial" scope="col">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, k) in paginated('items')" :key="`item-${k}`">
                            <th class="td-commercial" scope="row">{{data.user.name}} {{data.user.last_name}}</th>
                            <td class="td-commercial">{{data.caps.amount}}</td>
                            <td class="td-commercial">{{data.created_at}}</td>
                            <td class="td-commercial">{{data.status.name}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </paginate>
        <div class="row justify-content-center">
            <div class="col-12 col-md-9 col-lg-2 col-xl-2 col-sm-12 center-paginate">
                <div style="text-align: center">
                    <paginate-links @change="pageChange" for="items" :limit="2" :show-step-links="true"
                        :step-links="{next: '>', prev: '<'}"
                        :classes="{'ul': 'pagination', 'li': 'page-item', 'a': 'page-link'}">
                    </paginate-links>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                items: [],
                paginate: ['items'],
                page: 1,
                totalPage: 1,
            }
        },
        props: ['list'],
        watch: {

        },
        methods: {
            pageChange(toPage) {
                this.page = toPage;
            },

        },
        mounted() {
            this.items = this.list;
        }
    };
</script>
<style>
    ul.ul-pagination-c {
        padding-inline-start: 0px;
    }
    .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }
</style>